
import React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Text } from 'office-ui-fabric-react/lib/Text';

const LogoutLink = (props) => {
    return <Text><Link href="#/logout">Odhlásit</Link></Text>;
}

export default LogoutLink;
